/**
 * @file: vinHelper.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { kNullVIN } from '@euler/functions/constants';

const kNonVinChar = /[^ABCDEFGHJKLMNPRSTUVWXYZ1234567890]/g;

export function isValidVin(s: string) {
  return /^[ABCDEFGHJKLMNPRSTUVWXYZ1234567890]{17}$/.test(s);
}

export function validateVin(s: string) {
  if (isValidVin(s)) {
    return true;
  }
  return { error: '您输入的VIN码格式不正确' };
}

export function vinTransformed(s: string) {
  return s.toUpperCase().replace(kNonVinChar, '').slice(0, 17);
}

/**
 * What the two vehicle identity fields become on the wire. The form keeps
 * whatever the operator typed in both of them, so flipping the non-standard
 * toggle back and forth never loses input — the toggle alone decides which
 * number the order actually carries.
 */
export function vehicleIdentityFromForm(form: {
  isNonStandardVin: boolean;
  vin: string;
  chassisNo?: string;
}): { vin: string; chassisNo: string | null } {
  return form.isNonStandardVin
    ? { vin: kNullVIN, chassisNo: form.chassisNo?.trim() || null }
    : { vin: form.vin, chassisNo: null };
}
